import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import models.CareerStats
import models.CareerStatsCodec
import models.CompletedGame
import models.record

/**
 * The local player's lifetime stats: seeded from [PlayerPreferences] at startup, folded forward
 * once per finished game by the game screen, and read by the home screen's stats sheet. Mirrors
 * [PlusPass]'s singleton-plus-persistence shape so every screen sees the same live value.
 */
object CareerStatsStore {
    private var prefs: PlayerPreferences? = null
    private val mutableStats = MutableStateFlow(CareerStats())
    val stats: StateFlow<CareerStats> = mutableStats.asStateFlow()

    /** Seed from persistence. Call once at startup (alongside [PlusPass.init]). */
    fun init(playerPreferences: PlayerPreferences) {
        prefs = playerPreferences
        mutableStats.value = CareerStatsCodec.decode(playerPreferences.getCareerStatsJson())
    }

    fun record(game: CompletedGame): CareerStats {
        val updated = mutableStats.value.record(game)
        mutableStats.value = updated
        prefs?.setCareerStatsJson(CareerStatsCodec.encode(updated))
        return updated
    }

    fun reset() {
        mutableStats.value = CareerStats()
        prefs?.setCareerStatsJson(null)
    }
}
